import { useMutation, useQuery } from '@tanstack/react-query';

import { getProductDemo, postFeedback } from '@/components/app/demo/services';
import { PostFeedbackType } from '@/components/app/demo/services/type';
import { GetProductType } from '@/components/app/product/services/type';

import { GET_PRODUCT_DEMO, POST_FEEDBACK } from '@/constant/query-key';

export function useGetProductDemo(slug?: GetProductType) {
  return useQuery({
    queryKey: [GET_PRODUCT_DEMO, slug],
    queryFn: () => getProductDemo(slug),
  });
}

export function usePostFeedback() {
  return useMutation({
    mutationKey: [POST_FEEDBACK],
    mutationFn: (body: PostFeedbackType) => postFeedback(body),
  });
}
